//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class SendPaymentFailedMessageInputItem extends ItemBase {
    RecipientParentID: string | null = null;
    OriginalTransactionDate: string = "1970-01-01T00:00:00";
    Amount: number = 0;
    UseEmailTemplateSubjectAndBody: boolean = false;
    EmailSubject: string | null = null;
    EmailBody: string | null = null;
    BCCEmailToTeacher: boolean = false;

    constructor(initializer?: Partial<SendPaymentFailedMessageInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SendPaymentFailedMessageInputItem";
}
